<template>
  <transition name="streak-prompt">
    <div
      v-if="show"
      class="action-prompts"
    >
      <div
        class="action-prompts_inner"
        :class="{ 'action-prompts_inner_leave': leave }"
      >
        <LottieAnimation
          ref="fire"
          :animationData="animationData"
          :loop="true"
          :autoPlay="true"
          :speed="1"
          class="streak-prompt_fire lottie_fire anim-bounce-big_04"
          style="color: var(--clr-winning-streak); width: 6.5rem; position: relative; bottom: -1rem"
        />
        <div class="anim-flip-ins text-small weight_700 uppercase">
          {{ $t('common.streak') }}
        </div>
        <div class="anim-flip-ins text-large weight_700 uppercase">
          {{ streak.moves }}
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
// https://www.npmjs.com/package/lottie-web-vue?activeTab=readme
import { LottieAnimation } from 'lottie-web-vue'
import animationData from '@/assets/lottieJSONs/fire.json'

export default /** @type {any} */ {
  name: 'TrainerStreakPrompt',
  components: {
    LottieAnimation,
  },
  props: {
    streak: Object,
  },
  data() {
    return {
      show: false,
      leave: false,
      // show: true,
      winMoves: 0,
      winMovesTimeout: null,
      leaveTimeout: null,
      animationData,
    }
  },
  // --keep for dev
  // created() {
  //   this.show = true
  //   setInterval(() => {
  //     this.show = true
  //     this.timeoutHide()
  //   }, 3333)
  // },
  beforeUnmount() {
    clearTimeout(this.leaveTimeout)
    clearTimeout(this.winMovesTimeout)
  },
  methods: {
    timeoutHide() {
      this.leaveTimeout = setTimeout(() => {
        this.leave = true
      }, 1200)
      this.winMovesTimeout = setTimeout(() => {
        this.show = false
        this.leave = false
      }, 1400)
    },
  },
  watch: {
    streak() {
      this.show = this.streak.showPrompt
      if (this.show) {
        this.$store.dispatch('sounds_play', 'sound_winstreak_prompt')
        this.timeoutHide()
      }
    },
  },
}
</script>
<style lang="scss">
.lottie_fire {
  svg {
    path {
      fill: currentColor;
      &:nth-child(2) {
        stroke: transparent;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.action-prompts {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 10;
  height: 28rem;
  width: 28rem;
  padding: 0rem 1rem 2rem 1rem;
  border-radius: 50%;
  background: radial-gradient(var(--clr-black-0) 25%, transparent 60%);
  &_inner {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;
    right: 0;
    &_leave {
      opacity: 0;
      transition: 0.2s;
      transform: scale(0);
    }
  }
}
</style>
